import { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { Note, Page } from '../../../helbest';
import { API } from '../../../request/api';
import styles from './Address.module.css';
import Dataform from './Dataform/Dataform';

const AddressCreate = ({ Login, history, match }) => {
  const [region_list, set_region_list] = useState([]);
  const [lat, set_lat] = useState('35.6892');
  const [lng, set_lng] = useState('51.389');
  const [addr, set_addr] = useState('');
  const [region, set_region] = useState('');
  const [zip_code, set_zip_code] = useState('');
  const [show_new_addr, set_show_new_addr] = useState(false);

  const get_regions = () => {
    API.get
      .regions(Login.city_id)
      .then((response) => {
        if (response.success) {
          set_region_list(response.data);
        }
        return response;
      })
      .catch((error) => {
        console.error('Error : ', error);
      });
  };

  useEffect(() => {
    // user_location();
    get_regions();
    // eslint-disable-next-line
  }, []);

  const set_address = () => {
    API.post
      .userAddresses(region, addr, lat, lng, zip_code)
      .then((response) => {
        if (response.success) {
          Note.success('آدرس جدید افزوده شد');
          set_addr('');
          history.push('/delivery/');
        } else {
          Note.error(response.message);
        }
        return response;
      })
      .catch((error) => {
        Note.error('خطا در اتصال به سرور');
        console.error('Error : ', error);
      });
  };

  const back_address = '/delivery/';
  const new_addr = (new_address) => {
    if (new_address === 'new') {
      set_show_new_addr(!show_new_addr);
    }

    API.get
      .regions(Login.city_id)
      .then((response) => {
        if (response.success) {
          set_region_list(response.data);
        }
        return response;
      })
      .catch((error) => {
        console.error('Error : ', error);
      });
  };

  return (
    <Page
      address={back_address}
      back={true}
      className={`${styles.PageAddress} page-address`}
      footer={match.params.route === 'd' || match.params.route === 's' ? <div /> : null}
      header_back_title={
        match.params.route === 'd' || match.params.route === 's' ? `بازگشت به سبد` : ''
      }
      headerFix
      logo
      mobileContainer
      no_header_center_label={match.params.route === 'd' || match.params.route === 's'}
      showFooter
      title="آدرس ها">
      <div style={{ margin: '0 10px 100px 10px' }}>
        <label
          className="radio-input no-mr radio-ml adresses-container"
          style={{
            paddingRight: '8px',
            paddingLeft: '8px',
            paddingBottom: '8px',
            marginLeft: 0,
            marginRight: 0
          }}>
          <Dataform
            addr={addr}
            isInEditPage
            item={null}
            lat={lat}
            lng={lng}
            newAddr={new_addr}
            region={region}
            region_list={region_list}
            set_addr={set_addr}
            set_address={set_address}
            set_lat={set_lat}
            set_lng={set_lng}
            set_region={set_region}
            set_zip_code={set_zip_code}
            zip_code={zip_code}
          />
        </label>
      </div>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  Login: state.Login
});

export default connect(mapStateToProps)(AddressCreate);
